import { render, staticRenderFns } from "./tagArchives.vue?vue&type=template&id=dc5c19fe&"
import script from "./tagArchives.vue?vue&type=script&lang=js&"
export * from "./tagArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports